import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../context/MyContext";
// svgs
import Close from "../assets/icons/icon_close.png";

const TicketAlert = () => {
  const navigate = useNavigate();
  const { isOpenTicketAlert, setIsOpenTicketAlert, isAppMode, isUnderVersion } =
    useContext(MyContext);

  if (!isOpenTicketAlert) return null;

  const handleClose = () => {
    setIsOpenTicketAlert(false);
  };

  const handleSubscribe = () => {
    if (isAppMode && !isUnderVersion) {
      navigate("/subscription");
    } else {
      window.open(
        "https://dsstore.dongascience.com/product/gzs7BGyv",
        "_blank",
      );
    }
    setIsOpenTicketAlert(false);
  };

  const handleRegisterTicket = () => {
    window.open("https://my.dongascience.com/rewards/coupon", "_blank");
    setIsOpenTicketAlert(false);
  };

  return (
    <div className="modal">
      <div className="modal-content ticket-alert">
        <div className="ticket-alert__top flx-box">
          <img
            className="crs-btn"
            src={Close}
            onClick={handleClose}
            alt="close-btn"
          />
        </div>
        <div className="ticket-alert__content">
          <div className="ticket-alert__logo">
            <img
              src="https://img.dongascience.com/air/icon_logo_basic.svg"
              alt="과학동아 AIR 로고"
            />
          </div>
          <div className="ticket-alert__message">
            아직 궁금증이 풀리지 않았다면?
          </div>
          <div className="ticket-alert__buttons">
            <button
              className="ticket-alert__subscribe-btn crs-btn"
              onClick={handleSubscribe}
            >
              구독하고 계속 질문하기
            </button>
            <div className="ticket-alert__divider">
              <span>이용권이 있다면?</span>
              <button
                className="ticket-alert__register-btn crs-btn"
                onClick={handleRegisterTicket}
              >
                AIR 이용권 등록하기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketAlert;
